
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent6 as ObiWindApparent6Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-6.js';
 
 
 

 
 export const ObiWindApparent6 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-6',
   elementClass: ObiWindApparent6Element,
   events: {
     
   }
  });
 
 